import * as model from './model.js'
import recipeView from './views/recipeView.js'
import searchView from './views/searchView.js'
import resultsView from './views/resultView.js'
import paginationView from './views/paginationView.js'
import bookmarksView from './views/bookMarksView.js'
import AddRecipeView from './views/addRecipeView.js'
import addRecipeView from './views/addRecipeView.js'

///////////////////////////////////////

const controlRecipes = async function()
{
  try{
    
    // Getting the hash
    const hash = window.location.hash.slice(1);
    if(!hash) return;
    recipeView.renderSpiner();


    bookmarksView.update(model.state.bookmarks);
    
    // Loading recipe
    await model.loadRecipe(hash);
    recipeView.render(model.state.recipe);
    
    
    resultsView.update(model.getSearchResultsPage());


    
  }
  catch(err){
    recipeView.renderError();
  }
}

const controlSearchResults = async function()
{
  try{
    
    const query = searchView.getQuery();
    if(query.trim() === '') return;
    resultsView.renderSpiner();
    await model.loadSearchResult(query);
    resultsView.render(model.getSearchResultsPage(1));
    
    // render the pagination
    
    paginationView.render(model.state.search);
    
  }
  catch(err)
  {
    console.log(err);
  }
}

const controlPagination = function(page)
{
  resultsView.render(model.getSearchResultsPage(page));
  paginationView.render(model.state.search);
}

const controlServings = function(servings)
{
  // Update the recipe serbings in the state
  model.updateServings(servings);

  // update the view
  recipeView.update(model.state.recipe);

}

const controlAddBookmark = function()
{
  
  if(!model.state.recipe.bookmarked)model.addBookmark(model.state.recipe);
  else model.deleteBookmark(model.state.recipe.id);
  
  
  recipeView.update(model.state.recipe);
  bookmarksView.render(model.state.bookmarks);
}

const controlBookmarks = function()
{
  bookmarksView.render(model.state.bookmarks);
}


const controlAddRecipe = async function(newrecipe)
{
  try{
    addRecipeView.renderSpiner();

    await model.uploadRecipeData(newrecipe);

    recipeView.render(model.state.recipe);
    addRecipeView.renderMessage();
    bookmarksView.render(model.state.bookmarks);

    window.history.pushState(null , '' , `#${model.state.recipe.id}`);

    setTimeout(function(){
      addRecipeView.toggleWindow();
    } , 3000);
  }
  catch(err)
  {
    addRecipeView.renderError(err.message);
  }


}

const init = function()
{
  addRecipeView.addHandlerUpload(controlAddRecipe);
  recipeView.addHandlerRender(controlRecipes);
  recipeView.addHandlerUpdateServings(controlServings);
  searchView.handleSearch(controlSearchResults);
  paginationView.addHandlerClick(controlPagination);
  recipeView.addHandlerBookmark(controlAddBookmark);
  bookmarksView.addHandlerRenderBokkmarks(controlBookmarks);
  console.log('HELLO From THE New VERSION');
}
init();

